import { create } from 'zustand';

interface CommentUpdateRow {
  id: number;
  comment: string | null;
}

interface CommentUpdateState {
  isOpen: boolean;
  row: CommentUpdateRow;
  newComment: string;
  onCommentUpdateClose: () => void;
  onCommentUpdateOpen: (row: CommentUpdateRow, type: string) => void;
  setNewComment: (comment: string) => void;
  type: string;
}

export const useCommentUpdateStore = create<CommentUpdateState>(set => ({
  isOpen: false,
  row: { id: 0, comment: null },
  type: '',
  newComment: '',
  onCommentUpdateClose: () => set({ isOpen: false, newComment: '' }),
  onCommentUpdateOpen: (row, type) =>
    set({
      isOpen: true,
      row,
      type,
      newComment: row.comment || '',
    }),
  setNewComment: (comment: string) => set({ newComment: comment }),
}));
